// removed by extract-text-webpack-plugin
module.exports = {"loginContainer":"src-pages----login-module---loginContainer----jnJz","section":"src-pages----login-module---section---4Ut-X","field":"src-pages----login-module---field---1q21D","labelWithLink":"src-pages----login-module---labelWithLink---hhpYO","checkboxField":"src-pages----login-module---checkboxField---2Z_yX","rememberUserId":"src-pages----login-module---rememberUserId---3Hu3L","button":"src-pages----login-module---button---1k8ac","submit":"src-pages----login-module---submit---1ySMq","links":"src-pages----login-module---links---3WPhK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login.module.less
// module id = 276
// module chunks = 230539012308250